import React from 'react';
import { WHATSAPP_URL } from '../utils/whatsapp';

function Availability() {
  return (
    <section className="availability section-wrap">
      <span className="eyebrow">09 / Wherever your story takes you</span>
      <h2>Rooted in feeling.<br /><em>Available everywhere.</em></h2>
      <div className="availability-row">
        <p>Based in New York, creating alongside couples across the world — from coastal cliffs to city rooftops.</p>
        <a
          className="underlined-link"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Let’s make something beautiful <span>↗</span>
        </a>
      </div>
    </section>
  );
}

export default Availability;
